export const IT_SERVICES = new Set(['it-teknologi', 'windows', 'wifi-netvaerk', 'pc-hjaelp', 'gaming-pc']);
const CAMPAIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid'];

export function requestUrl(page, search = '') {
  const incoming = new URLSearchParams(search);
  const params = new URLSearchParams({ seo_landing: page.slug });
  if (page.category_id) params.set('kategori', page.category_id);
  for (const name of CAMPAIGN_PARAMS) if (incoming.get(name)) params.set(name, incoming.get(name));
  return `/beskriv-problem?${params}`;
}

export function initialCategory(categories, search) {
  const params = new URLSearchParams(search);
  const explicitId = categories.find(c => c.id === params.get('kategori'));
  if (explicitId) return explicitId.id;
  const requested = params.get('category');
  const slug = ['it', 'it-teknologi'].includes(requested) ? 'it-net' : requested;
  const explicit = categories.find(c => c.slug === slug);
  if (explicit) return explicit.id;
  const itAd = params.get('utm_source')?.toLowerCase() === 'google'
    && params.get('utm_medium')?.toLowerCase() === 'cpc'
    && /^it(?:[-_].+)?$/i.test(params.get('utm_campaign') || '');
  if (itAd || IT_SERVICES.has(params.get('seo_landing'))) return categories.find(c => c.slug === 'it-net')?.id || '';
  return '';
}

const EXAMPLES = {
  'it-net': {
    heading: 'Beskriv dit IT-problem', title: 'Kort titel, fx Mit WiFi falder hele tiden ud',
    description: 'Fx: Min computer er blevet meget langsom, og jeg ved ikke hvorfor.',
    specialties: 'Fx: Windows 11, WiFi, PC-opsætning', tried: 'Fx: Jeg har genstartet computeren og prøvet at opdatere Windows. Fejlen kommer stadig.',
  },
  markedsfoering: {
    heading: 'Beskriv din opgave', title: 'Kort titel, fx Mine annoncer giver ingen henvendelser',
    description: 'Fx: Jeg annoncerer for min virksomhed, men får få henvendelser. Jeg vil gerne have hjælp til at forbedre kampagnen.',
    specialties: 'Fx: Google Ads, annoncer, målgruppe', tried: 'Fx: Jeg har ændret teksten og målgruppen, men får stadig få henvendelser.',
  },
  general: {
    heading: 'Hvad er problemet?', title: 'Giv dit problem en kort titel',
    description: 'Beskriv hvad du vil have hjælp til, og hvad der driller.',
    specialties: 'Fx: emne, udstyr eller en konkret fejl', tried: 'Fortæl kort hvad du allerede har prøvet. Du kan også springe dette over.',
  },
};
export const requestExamples = slug => EXAMPLES[slug] || EXAMPLES.general;
export const newRequestKey = () => globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
export function readRequestDraft() {
  try { const draft = JSON.parse(sessionStorage.getItem('en_pending_problem') || '{}'); return draft && typeof draft === 'object' && !Array.isArray(draft) ? draft : {}; } catch { return {}; }
}

// Functional context only. Campaign data stays in the existing consent-aware attribution store.
export function requestEntrySource(params) {
  const source = new URLSearchParams();
  for (const key of ['category', 'kategori', 'service', 'seo_landing', 'ekspert']) {
    if (params.has(key)) source.set(key, params.get(key));
  }
  return source.toString();
}

export function pendingRequestDestination() {
  const draft = readRequestDraft();
  if (!draft.description?.trim()) return null;
  if (typeof draft.entrySource === 'string') {
    return `/beskriv-problem${draft.entrySource ? `?${draft.entrySource}` : ''}`;
  }
  const params = new URLSearchParams();
  if (draft.categoryId) params.set('kategori', draft.categoryId);
  if (draft.seoLandingParam) params.set('seo_landing', draft.seoLandingParam);
  return `/beskriv-problem?${params}`;
}
